import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { BadgeComponent, PlaceloaderComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-position-description-insert-ai-message',
  templateUrl: './position-description-insert-ai-message.component.html',
  styleUrls: ['./position-description-insert-ai-message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BadgeComponent, PlaceloaderComponent, TranslatePipe],
})
export class PositionDescriptionInsertAiMessageComponent {
  public readonly isLoading = input<boolean>(false);
}
